import { motion } from "framer-motion";

// Animation variants 
const getBlogCardVariant = (i) => {
  return {
    hidden: { opacity: 0, x: -100 - (i * 10) }, // Start from the left
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5, delay: i * 0.1 } // Add a slight delay based on the card index
    }
  };
}

const BlogSection = () => {

  const handleReadMore = (e) => {
    window.open('https://blog.equibre.com', '_blank');
  }

  return (
    <section className="work-section blogs-section">
      <div className="inner">
        <div className="col">
          <h1 className="impact-hdr">Blogs</h1>
        </div>
        <div className="services-container" style={{ flexWrap: 'nowrap' }}>
          <motion.div
            initial="hidden"
            variants={getBlogCardVariant(0)}
            whileInView={"visible"} className="service-card small -st">
            <div className="inner">
              <div className="image">
                <img src="http://blog.equibre.com/wp-content/uploads/2024/07/ecommerce_dev-scaled.jpg" />
              </div>
              <div className="overlay">
                <a href="https://blog.equibre.com/ecommerce-website-development/" target="_blank" className="text-button black">Ecommerce development &rarr;</a>
              </div>
            </div>
          </motion.div>
          <motion.div
            initial="hidden"
            variants={getBlogCardVariant(1)}
            whileInView={"visible"} className="service-card small">
            <div className="inner">
              <div className="image">
                <img src="http://blog.equibre.com/wp-content/uploads/2024/07/pexels-tara-winstead-8386440.jpg" />
              </div>
              <div className="overlay">
                <a href="https://blog.equibre.com/openai-integration/" target="_blank" className="text-button black">OpenAI Integration &rarr;</a>
              </div>
            </div>
          </motion.div>
          <motion.div
            initial="hidden"
            variants={getBlogCardVariant(2)}
            whileInView={"visible"} className="service-card small">
            <div className="inner">
              <div className="image">
                <img src="http://blog.equibre.com/wp-content/uploads/2024/07/pexels-negativespace-34600.jpg" />
              </div>
              <div className="overlay">
                <a href="https://blog.equibre.com/wordpress-development-services/" target="_blank" className="text-button black">Wordpress development &rarr;</a>
              </div>
            </div>
          </motion.div>
          <motion.div
            initial="hidden"
            variants={getBlogCardVariant(3)}
            whileInView={"visible"} className="service-card small">
            <div className="inner">
              <div className="image">
                <img src="http://blog.equibre.com/wp-content/uploads/2024/07/pexels-mart-production-7550581.jpg" />
              </div>
              <div className="overlay">
                <a href="https://blog.equibre.com/new-startup-idea/" target="_blank" className="text-button black">Startup idea &rarr;</a>
              </div>

            </div>
          </motion.div>
        </div>
        <div className="col">
          <button onClick={handleReadMore} className="text-button black">READ MORE ↗</button>
        </div>
      </div>
    </section>
  );
}

export default BlogSection;